import { render, staticRenderFns } from "./OverlayLoading.vue?vue&type=template&id=b883fbfa&scoped=true"
import script from "./OverlayLoading.vue?vue&type=script&lang=js"
export * from "./OverlayLoading.vue?vue&type=script&lang=js"
import style0 from "./OverlayLoading.vue?vue&type=style&index=0&id=b883fbfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b883fbfa",
  null
  
)

export default component.exports